export const getBackendUri = () => {
  switch (process.env.NEXT_PUBLIC_WORKING_ENV) {
    case 'staging':
      return 'https://staging-core.guestit.se';
    case 'production':
      return 'https://core.guestit.se';
    case 'localhost':
    default:
      return 'http://localhost:8080';
  }
};

export const BACKEND_URI = getBackendUri();

export const getClientUri = () => {

  switch (process.env.NEXT_PUBLIC_WORKING_ENV) {
    case 'staging':
      return 'https://staging.guestit.se';
    case 'production':
      return 'https://guestit.se';
    case 'localhost':
    default:
      return 'http://localhost:3000';
  }
};

export const CLIENT_URI = getClientUri();
